/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1ExamQuestionLibraryAiCorrection200,
  PostApiV1ExamQuestionLibraryAiCorrection400,
  PostApiV1ExamQuestionLibraryAiCorrection401,
  PostApiV1ExamQuestionLibraryAiCorrection500,
  PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest,
  PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse,
} from "../../types/examQuestionLibraryController/PostApiV1ExamQuestionLibraryAiCorrection.ts";
import { examItemRevisionResultViewModelSchema } from "../examItemRevisionResultViewModelSchema.ts";
import { examTypeListValueEditorViewModelSchema } from "../examTypeListValueEditorViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1ExamQuestionLibraryAiCorrection200Schema = z.lazy(
  () => examItemRevisionResultViewModelSchema,
) as unknown as ToZod<PostApiV1ExamQuestionLibraryAiCorrection200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1ExamQuestionLibraryAiCorrection400Schema =
  z.any() as unknown as ToZod<PostApiV1ExamQuestionLibraryAiCorrection400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1ExamQuestionLibraryAiCorrection401Schema =
  z.any() as unknown as ToZod<PostApiV1ExamQuestionLibraryAiCorrection401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1ExamQuestionLibraryAiCorrection500Schema =
  z.any() as unknown as ToZod<PostApiV1ExamQuestionLibraryAiCorrection500>;

export const postApiV1ExamQuestionLibraryAiCorrectionMutationRequestSchema =
  z.object({
    ComponentType: z.number().int(),
    Weight: z.optional(z.number().int().min(0).max(2147483647)),
    CultureInfo: z.string().min(0).max(10),
    Label: z.string().min(0).max(16000),
    Information: z.optional(z.string().min(0).max(4000)),
    FilePath: z.optional(z.string()),
    FileName: z.optional(z.string()),
    ShowLabel: z.optional(z.boolean()),
    ShowInformation: z.optional(z.boolean()),
    Required: z.optional(z.boolean()),
    Fixed: z.optional(z.boolean()),
    PageBreak: z.optional(z.boolean()),
    DisciplineId: z.optional(z.number().int()),
    ParentExamItemId: z.optional(z.number().int()),
    PersonAuthorId: z.number().int(),
    CurrentFilePath: z.optional(z.string()),
    HasFile: z.optional(z.boolean()),
    File: z.optional(z.instanceof(File)),
    RandomizeAlternatives: z.optional(z.boolean()),
    IsAdministrative: z.optional(z.boolean()),
    Status: z.optional(z.number().int()),
    Level: z.optional(z.number().int()),
    StatusJustification: z.optional(z.string()),
    Active: z.optional(z.boolean()),
    CompanyId: z.optional(z.number().int()),
    IsEvaluation: z.optional(z.boolean()),
    IsAiAssisted: z.optional(z.boolean()),
    MaxAudioTimeInSeconds: z.optional(z.number().int()),
    TeacherEvaluation: z.optional(z.boolean()),
    DecimalPlaces: z.optional(z.number().int().min(0).max(15)),
    Min: z.optional(z.number()),
    Max: z.optional(z.number()),
    CorrectAnswer: z.optional(z.string()),
    MaxFileSizeInMegabytes: z.optional(z.number().int().min(1).max(30)),
    AcceptedFormats: z.optional(z.array(z.string())),
    "ExamTypeList.Id": z.optional(z.number().int()),
    "ExamTypeList.Name": z.optional(z.string()),
    "ExamTypeList.IsInternal": z.optional(z.boolean()),
    "ExamTypeList.ExamTypeListValues": z.optional(
      z.array(z.lazy(() => examTypeListValueEditorViewModelSchema)),
    ),
    Subtype: z.optional(z.number().int()),
    ModelAnswer: z.optional(z.string().min(0).max(1000)),
    KeyTerms: z.optional(z.string().min(0).max(1000)),
  }) as unknown as ToZod<PostApiV1ExamQuestionLibraryAiCorrectionMutationRequest>;

export const postApiV1ExamQuestionLibraryAiCorrectionMutationResponseSchema =
  z.lazy(
    () => postApiV1ExamQuestionLibraryAiCorrection200Schema,
  ) as unknown as ToZod<PostApiV1ExamQuestionLibraryAiCorrectionMutationResponse>;
